// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"55":"d2b2f9dd","126":"0a2cf0b0","171":"5795d4ec","699":"21258447","833":"0643e270","842":"95a47192","998":"5e0758c7"}[chunkId] + ".chunk.js";
};